import { GetActivityModel } from "@factory/model/query-model-activity";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { activityFormDefault } from "./form.default";
import { ActivityFormSchema } from "./form.rule";

export const useFormDefaultActivity = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetActivityModel | undefined) => {
    return !cachedValue
      ? activityFormDefault
     : ({
        location: cachedValue.location,
        activityType: cachedValue.activity_type,
        name: cachedValue.name,
        description: cachedValue.description,
        isChildActivity: Boolean(cachedValue.is_child_activity),
        childRate: cachedValue.child_rate,
        showAsOptional: Boolean(cachedValue.show_as_optional),
        isFree: Boolean(cachedValue.is_free),
        entranceFee: cachedValue.entrance_fee,
      } as ActivityFormSchema);
  };

  return {
    getDefault,
  };
};
